import { Link } from "react-router-dom"

import {
  Calendar,
  Phone,
  MapPin,
  Clock,
  Building,
  CheckCircle,
  Truck,
} from "lucide-react"
import SEO from "./SEO"

import { Button } from "../components/ui/button"
import { Card, CardContent } from "../components/ui/card"
import { Badge } from "../components/ui/badge"

import { useParams } from "react-router-dom"
import { useEffect, useState } from "react"

export default function LocationPage(){

const { slug } = useParams()
const [pageData,setPageData] = useState(null)

useEffect(()=>{

fetch(`https://pranaam.pranaamhospitals.in/wp-json/wp/v2/pages?slug=${slug}`)
.then(res => res.json())
.then(data => setPageData(data[0]))

},[slug])

if(!pageData) return null

const acf = pageData.acf


  const locationpageSchema = [
  {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    "name": "Pranaam Hospitals – Nallagandla",
    "url": "https://pranaam.pranaamhospitals.in/locations/nallagandla",
    "logo": "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/logo.png",
    "description": "Pranaam Hospitals Nallagandla is a NABH-accredited multi-specialty hospital providing comprehensive healthcare, diagnostics, and 24/7 emergency services near Gachibowli, Hyderabad.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Nallagandla",
      "addressRegion": "Hyderabad",
      "addressCountry": "IN"
    },
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "contactType": "appointments",
        "telephone": "+91-99660-60000",
        "availableLanguage": ["English", "Telugu", "Hindi"]
      },
      {
        "@type": "ContactPoint",
        "contactType": "emergency",
        "telephone": "+91-98485-98285",
        "availableLanguage": ["English", "Telugu", "Hindi"]
      }
    ],
    "parentOrganization": {
      "@type": "MedicalOrganization",
      "name": "Pranaam Hospitals",
      "url": "https://pranaam.pranaamhospitals.in/"
    }
  },

  {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://pranaam.pranaamhospitals.in/locations/nallagandla"
    },
    "headline": "Pranaam Hospitals Nallagandla",
    "description": "Visit Pranaam Hospitals Nallagandla for expert medical care, advanced diagnostics, specialist consultations, and emergency services in Hyderabad.",
    "author": {
      "@type": "Organization",
      "name": "Pranaam Hospitals"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Pranaam Hospitals",
      "logo": {
        "@type": "ImageObject",
        "url": "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/logo.png"
      }
    },
    "datePublished": "2015-01-01",
    "dateModified": "2025-04-01",
    "keywords": [
      "Pranaam Hospitals Nallagandla",
      "hospital near Gachibowli",
      "emergency hospital Nallagandla",
      "multi specialty hospital Hyderabad"
    ]
  }
];

  return (
    <>
    <SEO
    title="Pranaam Hospitals Nallagandla | Multi-Specialty Hospital Near Gachibowli"
    description="Pranaam Hospitals Nallagandla offers expert doctors, advanced diagnostics, and 24/7 emergency care. Trusted multi-specialty hospital near Gachibowli, Hyderabad."
    canonical="https://pranaam.pranaamhospitals.in/locations/nallagandla"
    robots="index, follow"
    author="Pranaam Hospitals"
    publisher="Pranaam Hospitals"
    keywords="Pranaam Hospitals Nallagandla, hospital near Gachibowli Hyderabad,
                multi specialty hospital Nallagandla, emergency hospital Nallagandla,
                best doctors near Gachibowli, NABH hospital Hyderabad,
                diagnostics Nallagandla"
    schema={locationpageSchema}
    />

    <div className="min-h-screen bg-white">
      <main>
        {/* Hero Section */}
       <section className="relative py-16 md:py-24 bg-gradient-to-r from-gray-50 to-gray-100">
        <div className="container px-4 mx-auto">

        <div className="grid items-center grid-cols-1 gap-12 md:grid-cols-2">

        <div className="max-w-lg">

        <Badge className="mb-4 px-3 py-1 bg-primary/10 text-primary border-primary/20">
        <Building className="w-4 h-4 mr-1" />
        {acf.hero_badge}
        </Badge>

        <h1 className="mb-4 text-4xl font-bold tracking-tight md:text-5xl lg:text-6xl">
        {acf.branch_name} <span className="text-primary">Branch</span>
        </h1>

        <p className="mb-8 text-lg text-gray-700">
        {acf.hero_description}
        </p>

        <div className="flex flex-wrap gap-4">

        <Button size="lg" className="gap-2 shadow-md" asChild>
        <a href={acf.appointment_link} rel="noopener noreferrer">
        <Calendar className="mr-2 h-5 w-5"/>
        Book an Appointment
        </a>
        </Button>

        <Button
        size="lg"
        variant="outline"
        className="gap-2 border-primary text-primary hover:bg-primary hover:text-white"
        asChild
        >
        <a href={`tel:${acf.phone_number}`}>
        <Phone className="w-5 h-5"/>
        Call Us
        </a>
        </Button>

        </div>

        </div>


        <div className="relative">

        <div className="relative h-64 overflow-hidden rounded-lg shadow-xl md:h-96">

        <img
        src={acf.hero_image}
        alt={acf.branch_name}
        className="w-full h-full object-cover"
        />

        </div>

        <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-primary/10 rounded-full"></div>
        <div className="absolute -top-6 -left-6 w-24 h-24 bg-primary/10 rounded-full"></div>

        </div>

        </div>

        </div>
        </section>

        {/* Quick Info Section */}
     <section className="py-8 bg-white">
        <div className="container px-4 mx-auto">
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">

            {/* Location */}
            <Card className="transition-all hover:shadow-md">
                <CardContent className="p-6">
                <div className="flex items-center gap-4 mb-2">
                    <div className="p-3 rounded-full bg-primary/10">
                    <MapPin className="w-6 h-6 text-primary"/>
                    </div>
                    <h3 className="text-lg font-bold">Location</h3>
                </div>
                <p className="text-gray-700">
                    {acf.location_address}
                </p>
                </CardContent>
            </Card>

            {/* Contact */}
            <Card className="transition-all hover:shadow-md">
                <CardContent className="p-6">
                <div className="flex items-center gap-4 mb-2">
                    <div className="p-3 rounded-full bg-primary/10">
                    <Phone className="w-6 h-6 text-primary"/>
                    </div>
                    <h3 className="text-lg font-bold">Contact</h3>
                </div>
                <p className="text-gray-700">
                    <span className="block">
                    Phone: {acf.location_phone}
                    </span>
                    <span className="block">
                    Email: {acf.location_email}
                    </span>
                </p>
                </CardContent>
            </Card>

            {/* Hours */}
            <Card className="transition-all hover:shadow-md">
                <CardContent className="p-6">
                <div className="flex items-center gap-4 mb-2">
                    <div className="p-3 rounded-full bg-primary/10">
                    <Clock className="w-6 h-6 text-primary"/>
                    </div>
                    <h3 className="text-lg font-bold">Hours</h3>
                </div>
                <p className="text-gray-700">
                    <span className="block">
                    {acf.emergency_hours}
                    </span>
                    <span className="block">
                    {acf.opd_hours}
                    </span>
                </p>
                </CardContent>
            </Card>

            {/* Emergency */}
            <Card className="transition-all hover:shadow-md">
                <CardContent className="p-6">
                <div className="flex items-center gap-4 mb-2">
                    <div className="p-3 rounded-full bg-primary/10">
                    <Truck className="w-6 h-6 text-primary"/>
                    </div>
                    <h3 className="text-lg font-bold">Emergency</h3>
                </div>
                <p className="text-gray-700">
                    <span className="block">
                    {acf.emergency_info}
                    </span>
                    <span className="block">
                    {acf.ambulance_info}
                    </span>
                </p>
                </CardContent>
            </Card>

            </div>
        </div>
        </section>

        {/* About Branch Section */}
        <section className="py-12 bg-gray-50">
        <div className="container px-4 mx-auto">
            <div className="grid items-center grid-cols-1 gap-12 md:grid-cols-2">

            {/* Left Content */}
            <div>

                <Badge className="mb-2">
                {acf.about_badge}
                </Badge>

                <h2 className="mb-6 text-3xl font-bold md:text-4xl">
                {acf.about_title}{" "}
                <span className="text-primary">
                    {acf.about_branch_name}
                </span>
                </h2>

                <p className="mb-6 text-gray-700">
                {acf.about_description}
                </p>

                <div className="grid grid-cols-2 gap-4 mb-6">

                {acf.branch_features?.map((feature, index) => (
                    <div key={index} className="flex items-center gap-2">
                    <CheckCircle className="w-5 h-5 text-primary shrink-0" />
                    <span>{feature.feature_text}</span>
                    </div>
                ))}

                </div>

            </div>

            {/* Image */}
            <div className="relative">

                <div className="relative h-64 overflow-hidden rounded-lg shadow-xl md:h-96">

                <img
                    src={acf.about_image}
                    alt={acf.about_branch_name}
                    className="w-full h-full object-cover"
                />

                </div>

            </div>

            </div>
        </div>
        </section>

        {/* Location Map */}
       <section className="py-12 bg-white">
        <div className="container px-4 mx-auto">

            <div className="flex flex-col items-center mb-12 text-center">
            <Badge className="mb-2">
                {acf.map_badge}
            </Badge>

            <h2 className="mb-4 text-3xl font-bold md:text-4xl">
                {acf.map_title} <span className="text-primary">Location</span>
            </h2>
            </div>

            <div className="grid grid-cols-1 gap-8 md:grid-cols-2">

            {/* Map */}
            <div className="h-80 bg-gray-200 rounded-lg overflow-hidden">
                <iframe
                src={acf.map_embed_url}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                ></iframe>
            </div>

            {/* Address */}
            <div className="space-y-6">

                <div>

                <h3 className="text-xl font-bold">
                    {acf.hospital_name}
                </h3>

                <p className="text-muted-foreground">
                    {acf.map_address}
                </p>

                <div className="flex items-center gap-2 mt-2">
                    <Phone className="w-4 h-4 text-primary"/>
                    <span>Phone: {acf.map_phone}</span>
                </div>

                <div className="mt-4">
                    <Button variant="outline" size="sm" className="gap-2" asChild>
                    <a
                        href={acf.map_directions}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <MapPin className="w-4 h-4"/>
                        Get Directions
                    </a>
                    </Button>
                </div>

                </div>

            </div>

            </div>

        </div>
        </section>

        {/* CTA Banner */}
        <section className="py-12 bg-primary text-white">
        <div className="container px-4 mx-auto">

            <div className="flex flex-col items-center justify-between gap-6 md:flex-row">

            <div className="text-center md:text-left">

                <h2 className="mb-2 text-2xl font-bold md:text-3xl">
                {acf.cta_title}
                </h2>

                <p className="text-primary-foreground/90">
                {acf.cta_description}
                </p>

            </div>

            <div className="flex flex-wrap gap-4">

                <Button
                variant="secondary"
                size="lg"
                className="gap-2 shadow-md"
                asChild
                >
                <a
                    href={acf.cta_appointment_link}
                    rel="noopener noreferrer"
                >
                    <Calendar className="mr-2 h-5 w-5"/>
                    {acf.cta_button_text}
                </a>
                </Button>

                <Button
                variant="secondary"
                size="lg"
                className="gap-2 shadow-md"
                asChild
                >
                <a href={`tel:${acf.cta_phone}`}>
                    <Phone className="w-5 h-5"/>
                    {acf.cta_call_text}
                </a>
                </Button>

            </div>

            </div>

        </div>
        </section>
      </main>
    </div>
    </>
  )
}